"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationSummaryResponseModelStatus = void 0;
exports.ConversationSummaryResponseModelStatus = {
    Initiated: "initiated",
    InProgress: "in-progress",
    Processing: "processing",
    Done: "done",
    Failed: "failed",
};
